<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TPoLol/tc-custom/9780547537566.jpg?1734280655507" alt="This image is the cover for the book Blackpool Highflyer, The Jim Stringer Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blackpool Highflyer, The Jim Stringer Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>“A compelling thriller” set against the historical backdrop of Edwardian England’s railway system (<i>Daily Mail</i>).</b><br/>  <br/> Assigned to drive holidaymakers to the seaside resort of Blackpool in the hot summer of 1905, Jim Stringer is happy to have left behind the grime and danger of life in London. But his dreams of beer and pretty women are soon shattered when his high-speed train meets a huge millstone on the line, leading to a passenger’s death . . . <br/>  <br/> This is an atmospheric mystery of sabotage and suspicion, from an author who “does a stunning job of bringing to life the era when steam locomotives chugged from London through the British countryside” (<i>Booklist</i>).<br/>  <br/> “A clear winner in literary crime writing . . . Dazzling attention to detail and quality writing.” —<i>Daily Express</i><br/>  <br/> “A steamy whodunnit . . . This may well be the best fiction about the railways since Dickens.” —<i>The Independent on Sunday</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Martin
      </h2>
      
      <p class="authorDescription body article"> Andrew Martin was a Spectator (London) Young Writer of the Year and has written for the <I>Guardian</I>, the <I>Daily Telegraph</I>, and <I>Granta</I>. He has a weekly column in the New Statesman. He lives in London. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f844d34